import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=5322ac96&"
import script from "./ShopPage.vue?vue&type=script&lang=js&"
export * from "./ShopPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=5322ac96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports